/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import startModule, { StorePlayStartState } from './start';
import serviceModule, { StorePlayServiceState } from './service';
import orderModule, { StorePlayOrderState } from './order';

export interface StorePlayState {
  // modules
  start: StorePlayStartState;
  order: StorePlayOrderState;
  service: StorePlayServiceState;
}

export default {
  namespaced: true,
  modules: {
    start: startModule,
    service: serviceModule,
    order: orderModule,
  },
  state: {},
  getters: {},
  actions: {},
  mutations: {},
};
